import React, { useRef } from "react"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { HiPhone } from "react-icons/hi"
import { HiGlobeAlt } from "react-icons/hi2"
import { MdEmail } from "react-icons/md"
import { TiLocationOutline } from "react-icons/ti"
import contact from "services/contact"
import { useShowAlert } from "hooks/customAlert"
import { CgSpinner } from "react-icons/cg"
import { usePhoneMask } from "utils/phoneFormat"
import { useHideModal } from "hooks"
import ReCaptcha from "components/ReCaptcha"
export default ({ withAddress }) => {
  const { t } = useTranslation()
  const { error, success } = useShowAlert()
  const { hideModal } = useHideModal()

  const form = useRef()
  const [isValidForm, setIsValidForm] = useState(false)
  const [loading, setLoading] = useState(false)
  const phoneMask = usePhoneMask()
  const [reCaptcha, setReCaptcha] = useState("")
  const [message, setMessage] = useState("")

  const sendEmail = (e) => {
    e.preventDefault()

    const phoneDigits = phoneMask.value.replace(/\D/g, "")

    let validate =
      phoneDigits.length === 9 &&
      form?.current?.first_name?.value.trim().length &&
      form?.current?.last_name?.value.trim().length &&
      form?.current?.message?.value.trim().length &&
      reCaptcha?.length

    if (validate) {
      setLoading(true)
      const sentData = {
        phone: phoneMask.value.replace(/\D/g, ""),
        first_name: form?.current?.first_name?.value,
        last_name: form?.current?.last_name?.value,
        message: form?.current?.message?.value,
      }
      contact
        .sendMessage(sentData)
        .then(() => {
          form.current.phone.value = ""
          form.current.first_name.value = ""
          form.current.last_name.value = ""
          form.current.message.value = ""
          success(t("success_sent"))
          hideModal()
        })
        .catch((err) => {
          console.error(err)
          error(t("error_occurred"))
        })
        .finally(() => setLoading(false))
    } else {
      setIsValidForm(true)
    }
  }
  return (
    <div className="font-[Roboto] h-full z-50">
      <form ref={form} onSubmit={sendEmail} className="w-full text-white">
        <div>
          <span className="text-sm font-medium ">
            {t("connect-form-firstname")}
          </span>
          <input
            className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
            type="text"
            placeholder={t("connect-form-firstname")}
            name="first_name"
          />
        </div>
        <div className="mt-6">
          <span className="text-sm font-medium ">
            {t("connect-form-lastname")}
          </span>
          <input
            className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
            type="text"
            placeholder={t("connect-form-lastname")}
            name="last_name"
          />
        </div>
        <div className="mt-6">
          <span className="text-sm font-medium ">
            {t("connect-form-phone")}
          </span>
          <input
            {...phoneMask}
            className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
            placeholder={t("connect-form-phone")}
            type="text"
            name="phone"
          />
        </div>
        <div className="mt-6">
          <div className="flex items-center justify-between gap-5">
            <span className="text-sm font-medium ">
              {t("connect-form-message")}
            </span>
            <div className="text-sm font-medium">
              {message?.length ?? 0} / 300
            </div>
          </div>
          <textarea
            name="message"
            placeholder={t("connect-form-message")}
            rows={5}
            style={{
              resize: "none",
            }}
            onChange={(e) => setMessage(e.target.value)}
            maxLength={300}
            className="px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700 overflow-y-auto"
          />
        </div>

        <div className="flex items-center flex-col pb-[30px] relative">
          <div className="text-center">
            <ReCaptcha onChange={setReCaptcha} />
          </div>
        </div>

        <div
          className={`${
            !isValidForm ? "text-transparent hidden" : "text-red-500 block"
          }`}
        >
          {!form?.current?.first_name?.value.trim().length &&
          !form?.current?.last_name?.value.trim().length &&
          !form?.current?.message?.value.trim().length &&
          phoneMask.value.replace(/\D/g, "")?.length !== 9 ? (
            <p className="text-base text-red-500 bottom-1">
              {t("connect-form-error")}
            </p>
          ) : null}

          {!reCaptcha?.length && isValidForm ? (
            <p className="text-base text-red-500 bottom-1">
              * {t("not-robot")}
            </p>
          ) : null}
        </div>
        <div className="flex justify-end mt-6">
          <button
            onClick={sendEmail}
            className="font-[Inter] pt-5 py-4 px-9 w-full text-white font-semibold border  rounded-xl shadow-4xl hover:bg-gray-700 transition ease-in-out duration-200 flex items-center justify-center gap-5"
          >
            {t("connect-form-btn")}
            {loading ? <CgSpinner className="animate-spin" size={30} /> : null}
          </button>
        </div>
      </form>
      {withAddress && (
        <div className="w-full flex flex-wrap md:justify-center font-[Inter] py-4 pt-8">
          <div className="w-full ">
            <div className="flex flex-wrap justify-between w-full gap-5 text-white">
              <div className="grid grid-cols-2 gap-3">
                <div className="flex items-center justify-start gap-4">
                  <span>
                    <HiPhone size={20} color="white" />
                  </span>
                  <p>
                    <a
                      href="tel:+99873 244-05-35"
                      target="blank"
                      className="hover:cursor-pointer hover:underline"
                    >
                      +99873 244-05-35
                    </a>
                  </p>
                </div>
                <div className="flex items-center justify-start gap-4">
                  <span>
                    <MdEmail size={20} color="white" />
                  </span>
                  <p>farmarkaz@ferghana.uz</p>
                </div>
                <div className="flex items-center justify-start gap-4">
                  <span>
                    <HiGlobeAlt size={20} color="white" />
                  </span>
                  <a
                    href="http://fcc.uz/"
                    className="hover:cursor-pointer hover:underline"
                  >
                    fcc.uz
                  </a>
                </div>
              </div>
              <div
                className="flex items-start justify-start gap-4"
                start="true"
              >
                <span>
                  <TiLocationOutline size={24} color="white" />
                </span>
                <div className="flex flex-col gap-2">
                  <p>{t("connecting-address")}.</p>
                  <p>{t("connecting-address-full")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
